import Cookies from 'js-cookie';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  expressWmsPluginLink: '' // 桌面插件最新链接
};

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  /**
   * @description 设计插件链接
   * @param state
   * @param url
   * @constructor
   */
  SET_EXPRESS_WMS_PLUGIN_LINK(state, url) {
    state.expressWmsPluginLink = url;
  }
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  /**
   * @description 设置插件链接
   * @param commit
   * @param url
   */
  updateExpressWmsPluginLink({ commit }, url) {
    commit('SET_EXPRESS_WMS_PLUGIN_LINK', url);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
